import { Founder, CompatibilityScore } from './types'

// Individual founder objects for better readability and maintainability
const vijayKarunamurthy: Founder = {
  id: '1',
  name: 'Vijay Karunamurthy',
  archetype: 'CTO',
  skills: ['AI/ML', 'Product Management', 'Scalability', 'Enterprise'],
  previousCompanies: [
    {
      name: 'Scale AI',
      role: 'Field Chief Technology Officer',
      years: [2023, 2025],
    },
    {
      name: 'Scale AI',
      role: 'Head of Engineering, Product and Design',
      years: [2022, 2023],
    },
    { name: 'Apple', role: 'Director of Engineering', years: [2017, 2022] },
    { name: 'Nom Labs', role: 'Co-Founder and CEO', years: [2014, 2017] },
    { name: 'AVOS Systems', role: 'Co-Founder and CTO', years: [2010, 2014] },
    {
      name: 'Google/YouTube',
      role: 'Head of Search and Discovery Engineering',
      years: [2006, 2010],
    },
    { name: 'ETRADE', role: 'Senior Architect', years: [2000, 2005] },
  ],
  education: [
    { institution: 'UC Berkeley Haas', degree: 'MBA', year: 2011 },
    {
      institution: 'Stanford University',
      degree: 'MS Computer Science',
      year: 2006,
    },
    {
      institution: 'University of Illinois',
      degree: 'BS Biochemistry, BA Mathematics',
      year: 2000,
    },
  ],
  yearsExperience: 24,
  exitHistory: [
    { company: 'Confluent', year: 2000, value: 'Acquired by ETRADE' },
  ],
  velocityScore: 94,
  potentialScore: 92,
  photoUrl:
    'https://uploadthingy.s3.us-west-1.amazonaws.com/bJPXL7VKSZpCy9rJxXkXSy/pasted-image.jpg',
  linkedinUrl: 'https://www.linkedin.com/in/vjkaruna/',
}

const nidhiShanbhag: Founder = {
  id: '2',
  name: 'Nidhi Shanbhag',
  archetype: 'CEO',
  skills: ['Venture Capital', 'Crypto/Web3', 'Fintech'],
  previousCompanies: [
    { name: 'Distyl AI', role: 'GTM Advisor', years: [2023, 2025] },
    {
      name: 'Uniswap Labs',
      role: 'Head of Partnerships, BD and Ventures',
      years: [2022, 2025],
    },
    {
      name: 'KKR & Co. Inc.',
      role: 'Private Equity and Tech Growth Equity Investor',
      years: [2019, 2021],
    },
    {
      name: 'Berkshire Partners',
      role: 'Summer Vice President, Private Equity',
      years: [2018, 2018],
    },
    {
      name: 'Sequoia Capital',
      role: 'VC and growth Investor',
      years: [2015, 2017],
    },
    {
      name: 'The Boston Consulting Group',
      role: 'Management Consultant',
      years: [2013, 2015],
    },
  ],
  education: [
    { institution: 'Harvard Business School', degree: 'MBA', year: 2019 },
    {
      institution: 'Indian Institute of Technology, Bombay',
      degree: 'Bachelors and Masters',
      year: 2013,
    },
  ],
  yearsExperience: 12,
  exitHistory: [],
  velocityScore: 91,
  potentialScore: 93,
  photoUrl:
    'https://uploadthingy.s3.us-west-1.amazonaws.com/f7UifvU76jaL9rp7eZEC48/pasted-image.jpg',
  linkedinUrl: 'https://www.linkedin.com/in/nidhishanbhag/',
}

const rubenMayer: Founder = {
  id: '3',
  name: 'Ruben Mayer',
  archetype: 'CEO',
  skills: ['AI/ML', 'Health', 'Enterprise'],
  previousCompanies: [
    {
      name: 'Scale AI',
      role: 'SVP, Gen AI Product and Operations',
      years: [2024, 2025],
    },
    {
      name: 'Scale AI',
      role: 'VP, Gen AI',
      years: [2023, 2024],
    },
    {
      name: 'Scout AI',
      role: 'Co-Founder',
      years: [2022, 2023],
    },
    {
      name: 'Scale AI',
      role: 'Director of Strategic Product Management',
      years: [2020, 2022],
    },
    {
      name: 'Scale AI',
      role: 'Product Manager',
      years: [2019, 2019],
    },
    {
      name: 'FameGame TV',
      role: 'Founder',
      years: [2016, 2019],
    },
    {
      name: 'Lightspeed Venture Partners',
      role: 'Summer Fellow',
      years: [2016, 2016],
    },
    {
      name: 'Facebook',
      role: 'Summer Intern',
      years: [2015, 2015],
    },
  ],
  education: [
    {
      institution: 'Stanford University',
      degree: 'BS, MS, Computer Science, Economics',
      year: 2018,
    },
  ],
  yearsExperience: 10,
  exitHistory: [
    { company: 'Scout AI', year: 2023, value: 'Acquired by Scale AI' },
  ],
  velocityScore: 78,
  potentialScore: 90,
  photoUrl:
    'https://uploadthingy.s3.us-west-1.amazonaws.com/gWRPdAZ3L8TPVUm81uZKcq/pasted-image.jpg',
  linkedinUrl: 'https://www.linkedin.com/in/rubenmayer/',
}

const hariSrinivasan: Founder = {
  id: '4',
  name: 'Hari Srinivasan',
  archetype: 'CEO',
  skills: ['Product Management', 'Growth', 'Consumer', 'Monetization'],
  previousCompanies: [
    { name: 'LinkedIn', role: 'VP of Product', years: [2022, 2025] },
    {
      name: 'LinkedIn',
      role: 'Senior Director of Product Management',
      years: [2021, 2022],
    },
    {
      name: 'LinkedIn',
      role: 'Director of Product Management',
      years: [2019, 2020],
    },
    {
      name: 'LinkedIn',
      role: 'Head of Product, Professional Identity',
      years: [2016, 2019],
    },
    { name: 'LinkedIn', role: 'Senior Product Manager', years: [2013, 2015] },
    { name: 'LinkedIn', role: 'Product Manager', years: [2011, 2013] },
    { name: 'LinkedIn', role: 'Product Manager Intern', years: [2010, 2010] },
    {
      name: 'Ford Motor Company',
      role: 'Product Marketing Manager',
      years: [2003, 2008],
    },
  ],
  education: [
    {
      institution: 'Stanford University Graduate School of Business',
      degree: 'MBA',
      year: 2011,
    },
    {
      institution: 'University of Michigan',
      degree: 'BBA, Business Administration',
      year: 2003,
    },
  ],
  yearsExperience: 22,
  exitHistory: [],
  velocityScore: 92,
  potentialScore: 90,
  photoUrl:
    'https://uploadthingy.s3.us-west-1.amazonaws.com/7G77S3gR9kTf1bsrjB36jP/pasted-image.jpg',
  linkedinUrl: 'https://www.linkedin.com/in/hsrinivasan1/',
}

const tejasSundaresan: Founder = {
  id: '5',
  name: 'Tejas Sundaresan',
  archetype: 'CEO',
  skills: ['AI/ML', 'Enterprise', 'Product Management'],
  previousCompanies: [
    {
      name: 'Databricks',
      role: 'Product, Mosaic AI',
      years: [2024, 2025],
    },
    {
      name: 'Dialect',
      role: 'Co-Founder',
      years: [2022, 2024],
    },
    {
      name: 'Google',
      role: 'Product Manager',
      years: [2019, 2021],
    },
    {
      name: 'Google',
      role: 'Software Engineer',
      years: [2017, 2019],
    },
    {
      name: 'MIT CSAIL',
      role: 'Researcher',
      years: [2014, 2017],
    },
  ],
  education: [
    {
      institution: 'Stanford University Graduate School of Business',
      degree: 'MBA',
      year: 2022,
    },
    {
      institution: 'Massachusetts Institute of Technology',
      degree: 'Master of Engineering (M.Eng.), Computer Science',
      year: 2017,
    },
    {
      institution: 'Massachusetts Institute of Technology',
      degree: "Bachelor's degree, Computer Science",
      year: 2016,
    },
    {
      institution: 'North Carolina School of Science and Mathematics',
      degree: 'High School',
      year: 2012,
    },
  ],
  yearsExperience: 11,
  exitHistory: [{ company: 'Dialect', year: 2024, value: 'Acquired' }],
  velocityScore: 92,
  potentialScore: 94,
  photoUrl:
    'https://uploadthingy.s3.us-west-1.amazonaws.com/iPNyRXegRK97nfWmW3buMs/pasted-image.jpg',
  linkedinUrl: 'https://www.linkedin.com/in/tejassundaresan/',
}

const banshiShah: Founder = {
  id: '6',
  name: 'Bansi Shah',
  archetype: 'CEO',
  skills: ['Product Management', 'Health', 'Enterprise', 'Analytics'],
  previousCompanies: [
    { name: 'Google', role: 'Group Product Manager', years: [2017, 2025] },
    { name: 'IDEO', role: 'Business Design Intern', years: [2015, 2016] },
    { name: 'HealthCrew', role: 'Co-Founder/CTO', years: [2013, 2015] },
    { name: 'Hearsay Social', role: 'Product Manager', years: [2012, 2013] },
    {
      name: 'Lattice Engines',
      role: 'Manager of Proprietary Data Solutions',
      years: [2009, 2012],
    },
    {
      name: 'Facebook',
      role: 'Monetization Analytics Intern',
      years: [2010, 2010],
    },
    { name: 'Goldman Sachs', role: 'Technology Intern', years: [2008, 2008] },
    {
      name: 'Getco LLC',
      role: 'Software Engineering Intern',
      years: [2007, 2007],
    },
  ],
  education: [
    { institution: 'Harvard Business School', degree: 'MBA', year: 2017 },
    {
      institution: 'Stanford University',
      degree: 'BS, Mathematical and Computational Science',
      year: 2010,
    },
    {
      institution: 'Illinois Mathematics and Science Academy',
      degree: 'High School',
      year: 2006,
    },
  ],
  yearsExperience: 16,
  exitHistory: [],
  velocityScore: 92,
  potentialScore: 90,
  photoUrl:
    'https://uploadthingy.s3.us-west-1.amazonaws.com/eYrGMF5ecdV9BTjFZEcvte/pasted-image.jpg',
  linkedinUrl: 'https://www.linkedin.com/in/bansishah/',
}

const tommyWang: Founder = {
  id: '7',
  name: 'Tommy Wang',
  archetype: 'CEO',
  skills: ['Enterprise', 'SaaS', 'Marketplace'],
  previousCompanies: [
    { name: 'ClickUp', role: 'Chief Business Officer', years: [2019, 2024] },
    { name: 'Stealth Startup', role: 'Founder', years: [2024, 2025] },
    { name: 'Summit Partners', role: 'Investor', years: [2015, 2015] },
  ],
  education: [
    {
      institution: 'Dartmouth College',
      degree: "Bachelor's Degree, Economics & Public Policy",
      year: 2015,
    },
  ],
  yearsExperience: 10,
  exitHistory: [
    {
      company: 'ClickUp',
      year: 2024,
      value: 'Scaled to $200M+ ARR, $4B valuation',
    },
  ],
  velocityScore: 95,
  potentialScore: 94,
  photoUrl:
    'https://uploadthingy.s3.us-west-1.amazonaws.com/5pPHP9nQw3Tcp6g79nZxQj/pasted-image.jpg',
  linkedinUrl: 'https://www.linkedin.com/in/wagshq/',
}

const yongxingDeng: Founder = {
  id: '8',
  name: 'Yongxing Deng',
  archetype: 'CTO',
  skills: ['AI/ML', 'Enterprise', 'SaaS'],
  previousCompanies: [
    { name: 'Aloft', role: 'Co-Founder and CTO', years: [2020, 2023] },
    { name: 'Permira', role: 'Investment Intern', years: [2020, 2020] },
    {
      name: 'Slack',
      role: 'Engineering Manager, Data Tools',
      years: [2017, 2019],
    },
    { name: 'Slack', role: 'Staff Software Engineer', years: [2015, 2017] },
    {
      name: 'Asana',
      role: 'Software Engineering Intern',
      years: [2013, 2013],
    },
    {
      name: 'Dropbox',
      role: 'Software Engineering Intern',
      years: [2012, 2012],
    },
  ],
  education: [
    {
      institution: 'Harvard Business School',
      degree: 'MBA with High Distinction',
      year: 2021,
    },
    {
      institution: 'Stanford University',
      degree: 'BS + MS, Computer Science, Artificial Intelligence',
      year: 2015,
    },
  ],
  yearsExperience: 11,
  exitHistory: [],
  velocityScore: 93,
  potentialScore: 91,
  photoUrl:
    'https://uploadthingy.s3.us-west-1.amazonaws.com/6NkkvBMVAwuXBb5buGWBhz/pasted-image.jpg',
  linkedinUrl: 'https://www.linkedin.com/in/yongxing-deng/',
}

const kevinChan: Founder = {
  id: '9',
  name: 'Seven of Nine',
  archetype: 'CTO',
  skills: ['AI/ML', 'Enterprise', 'Fintech'],
  previousCompanies: [
    {
      name: 'Unicorn Startup',
      role: 'Staff Software Engineer, Procurement',
      years: [2023, 2025],
    },
    {
      name: 'Seed Startup',
      role: 'Co-Founder, CPO',
      years: [2022, 2023],
    },
    {
      name: 'Series C startup',
      role: 'Engineering Lead',
      years: [2022, 2022],
    },
    {
      name: 'Meta',
      role: 'Senior Software Engineer',
      years: [2022, 2022],
    },
    {
      name: 'Meta',
      role: 'Software Engineer',
      years: [2020, 2021],
    },
  ],
  education: [
    {
      institution: 'Cornell University',
      degree: 'Bachelor of Science - BS, Computer Science',
      year: 2020,
    },
    {
      institution: 'Cornell University',
      degree: 'Master of Engineering - MEng, Computer Science',
      year: 2020,
    },
  ],
  yearsExperience: 5,
  exitHistory: [
    {
      company: 'Seed Startup',
      year: 2023,
      value: 'Acquired by Unicorn Startup',
    },
  ],
  velocityScore: 92,
  potentialScore: 89,
  photoUrl:
    'https://uploadthingy.s3.us-west-1.amazonaws.com/mm9wQtDsj4MmLpFRjYSpuZ/pasted-image.webp',
  linkedinUrl: 'https://www.linkedin.com/in/kevinchan159/',
}

const veeralPatel: Founder = {
  id: '10',
  name: 'Veeral Patel',
  archetype: 'CTO',
  skills: ['Fintech', 'Consumer', 'SaaS'],
  previousCompanies: [
    {
      name: 'Ramp',
      role: 'Director, Software Engineering',
      years: [2019, 2025],
    },
    {
      name: 'Ramp',
      role: 'Founding Engineer',
      years: [2019, 2025],
    },
    {
      name: 'Workflow HQ',
      role: 'Founding Engineer',
      years: [2014, 2015],
    },
  ],
  education: [
    {
      institution: 'Stanford University',
      degree: 'Computer Science',
      year: 2014,
    },
  ],
  yearsExperience: 11,
  exitHistory: [
    {
      company: 'Workflow HQ',
      year: 2015,
      value: 'Acquired by Apple (now Shortcuts)',
    },
  ],
  velocityScore: 93,
  potentialScore: 90,
  photoUrl:
    'https://uploadthingy.s3.us-west-1.amazonaws.com/uHUpttakHE7veWmk6hUStD/pasted-image.jpg',
  linkedinUrl: 'https://www.linkedin.com/in/patelveeral/',
}

// Founders 11-30 with more consistent structure
const andrewWerner: Founder = {
  id: '11',
  name: 'Andrew Werner',
  archetype: 'CEO',
  skills: [
    'Software Engineering',
    'Java',
    'Databases',
    'Distributed Systems',
    'Enterprise',
    'SaaS',
  ],
  previousCompanies: [
    { name: 'Datadog', role: 'Staff Engineer', years: [2025, 2025] },
    { name: 'Merit', role: 'Investor', years: [2021, 2025] },
    { name: 'Data Ex Machina', role: 'Co-Founder', years: [2023, 2025] },
    {
      name: 'Cockroach Labs',
      role: 'Member Of Technical Staff',
      years: [2018, 2023],
    },
    {
      name: 'Western Digital',
      role: 'Senior Technologist',
      years: [2017, 2018],
    },
  ],
  education: [
    {
      institution: 'Princeton University',
      degree: 'BS, Computer Science',
      year: 2014,
    },
  ],
  yearsExperience: 8,
  exitHistory: [{ company: 'Data Ex Machina', year: 2025, value: 'Acquired' }],
  velocityScore: 88,
  potentialScore: 86,
  photoUrl:
    'https://uploadthingy.s3.us-west-1.amazonaws.com/wBf4UPfoNd4QTPmG53xXpB/pasted-image.jpg',
  linkedinUrl: 'https://www.linkedin.com/in/andrew-werner-8228a438/',
}

const anubhavJain: Founder = {
  id: '12',
  name: 'Anubhav Jain',
  archetype: 'CTO',
  skills: [
    'Enterprise',
    'AI/ML',
    'Software Engineering',
    'IoT',
    'Computer Vision',
  ],
  previousCompanies: [
    {
      name: 'Samsara, Inc',
      role: 'Software Engineering Manager',
      years: [2017, 2022],
    },
    { name: 'MIT CSAIL', role: 'Research Assistant', years: [2016, 2017] },
    { name: 'MIT', role: 'Graduate Teaching Assistant', years: [2016, 2016] },
    {
      name: 'Meteor Development Group',
      role: 'Software Engineering Intern',
      years: [2015, 2015],
    },
    {
      name: 'Google',
      role: 'Software Engineering Intern',
      years: [2014, 2014],
    },
    {
      name: 'Homejoy',
      role: 'Android Development Intern',
      years: [2014, 2014],
    },
    {
      name: 'Infinite Analytics',
      role: 'Software Engineering Intern',
      years: [2013, 2013],
    },
  ],
  education: [
    {
      institution: 'Massachusetts Institute of Technology',
      degree: "Bachelor's degree, Computer Science",
      year: 2016,
    },
  ],
  yearsExperience: 9,
  exitHistory: [],
  velocityScore: 82,
  potentialScore: 77,
  photoUrl:
    'https://uploadthingy.s3.us-west-1.amazonaws.com/wZkL7Bmqy2Zhm1RnVyrAC2/pasted-image.jpg',
  linkedinUrl: 'https://www.linkedin.com/in/anubhav-jain-mit/',
}

const divannyLamas: Founder = {
  id: '13',
  name: 'Kathryn Janeway',
  archetype: 'CEO',
  skills: ['Enterprise', 'SaaS', 'Marketplace'],
  previousCompanies: [
    { name: 'Breakthrough Startup', role: 'CEO', years: [2019, 2024] },
    {
      name: 'VC Firm',
      role: 'Managing Director',
      years: [2019, 2022],
    },
    {
      name: 'Unicorn Startup',
      role: 'Head of New Product Introduction',
      years: [2018, 2019],
    },
    {
      name: 'Unicorn Startup',
      role: 'Sr. Director, Customer Success',
      years: [2017, 2018],
    },
    {
      name: 'Unicorn Startup',
      role: 'Head of Product - Platform',
      years: [2013, 2015],
    },
    {
      name: 'Google',
      role: 'Ops @ Google Enterprise Apps',
      years: [2010, 2011],
    },
  ],
  education: [
    {
      institution: 'Harvard University',
      degree: 'A.B., Government and Computer Science',
      year: 2008,
    },
  ],
  yearsExperience: 16,
  exitHistory: [
    {
      company: 'Breakthrough Startup',
      year: 2024,
      value: 'IP Sale to Public Company',
    },
  ],
  velocityScore: 88,
  potentialScore: 92,
  photoUrl:
    'https://uploadthingy.s3.us-west-1.amazonaws.com/52eRQFiGewCM8aUatc2rjS/pasted-image.webp',
  linkedinUrl: 'https://www.linkedin.com/in/divanny/',
}

const joshuaPenman: Founder = {
  id: '14',
  name: 'Joshua Penman',
  archetype: 'CTO',
  skills: ['AI/ML', 'Enterprise', 'Search Infrastructure', 'LLM Engineering'],
  previousCompanies: [
    { name: 'South Park Commons', role: 'Founder Fellow', years: [2025, 2025] },
    { name: 'Asana', role: 'AI Workflows Technical Lead', years: [2024, 2025] },
    {
      name: 'Asana',
      role: 'LLM Foundations Technical Lead',
      years: [2023, 2024],
    },
    {
      name: 'Asana',
      role: 'Lead, Deployment Velocity and Reliability',
      years: [2020, 2023],
    },
    {
      name: 'Asana',
      role: 'Engineering Program Lead, Customer Scaling',
      years: [2019, 2020],
    },
    {
      name: 'Asana',
      role: 'Engineering Technical Lead, Product',
      years: [2018, 2019],
    },
    { name: 'Asana', role: 'Software Engineer', years: [2015, 2018] },
  ],
  education: [
    {
      institution: 'Yale University',
      degree: "Bachelor's degree, Music and Mathematics",
      year: 2010,
    },
    {
      institution: 'University of Michigan',
      degree: 'Master of Music, Doctor of Musical Arts, Composition',
      year: 2014,
    },
  ],
  yearsExperience: 10,
  exitHistory: [],
  velocityScore: 84,
  potentialScore: 79,
  photoUrl:
    'https://uploadthingy.s3.us-west-1.amazonaws.com/b4KFTmJP4EG364UoZqbzP8/pasted-image.jpg',
  linkedinUrl: 'https://www.linkedin.com/in/joshuasp/',
}

const kailiLiang: Founder = {
  id: '15',
  name: 'Kaili Liang',
  archetype: 'CTO',
  skills: ['Consumer', 'SaaS', 'Frontend Engineering', 'UI/UX'],
  previousCompanies: [
    { name: 'Slack', role: 'Software Engineer I', years: [2024, 2025] },
    { name: 'Slack', role: 'Associate Software Engineer', years: [2023, 2024] },
    {
      name: 'Kleiner Perkins',
      role: 'Engineering Fellow',
      years: [2022, 2025],
    },
    { name: 'Slack', role: 'Software Engineer Intern', years: [2022, 2022] },
    { name: 'Jailed for Melanin', role: 'Co-Founder', years: [2020, 2021] },
    { name: 'Slack', role: 'Software Engineer Intern', years: [2021, 2021] },
    {
      name: 'Tufts University',
      role: 'Teaching Assistant',
      years: [2020, 2020],
    },
    {
      name: 'Uber',
      role: 'UberSTAR Software Engineer Intern',
      years: [2020, 2020],
    },
    {
      name: 'Pinterest',
      role: 'Pinterest Engage Scholar',
      years: [2020, 2020],
    },
    { name: 'Mathnasium', role: 'Mathematics Instructor', years: [2018, 2018] },
    { name: 'Neurotrack', role: 'Analyst', years: [2016, 2018] },
    {
      name: "The Women's Foundation",
      role: 'Communication and Events Intern',
      years: [2017, 2017],
    },
  ],
  education: [
    {
      institution: 'Tufts University',
      degree: 'Bachelors of Science, Computer Science',
      year: 2023,
    },
    {
      institution: 'Crystal Springs Uplands School',
      degree: 'High School',
      year: 2019,
    },
  ],
  yearsExperience: 5,
  exitHistory: [],
  velocityScore: 85,
  potentialScore: 80,
  photoUrl:
    'https://uploadthingy.s3.us-west-1.amazonaws.com/fRSLDVmTGVvUPLqjZtQKVg/pasted-image.jpg',
  linkedinUrl: 'https://www.linkedin.com/in/kaili-liang/',
}

const kevinDonahoe: Founder = {
  id: '16',
  name: 'Kevin Donahoe',
  archetype: 'CTO',
  skills: ['Security', 'AI/ML', 'Enterprise'],
  previousCompanies: [
    {
      name: 'Palantir Technologies',
      role: 'Product & GTM',
      years: [2022, 2024],
    },
    {
      name: 'Palantir Technologies',
      role: 'Forward Deployed Engineering Lead | Enterprise & Government',
      years: [2018, 2022],
    },
    {
      name: 'Palantir Technologies',
      role: 'Forward Deployed Engineering',
      years: [2017, 2018],
    },
    {
      name: 'Palantir Technologies',
      role: 'Privacy and Civil Liberties Engineering',
      years: [2016, 2016],
    },
    {
      name: 'Neukom Digital Arts Leadership and Innovation Lab (DALI)',
      role: 'Web Developer',
      years: [2015, 2015],
    },
    { name: 'GSVlabs', role: 'Investment Analyst', years: [2014, 2014] },
  ],
  education: [
    {
      institution: 'Dartmouth College',
      degree: "Bachelor's degree, Computer Science",
      year: 2016,
    },
    {
      institution: 'Sacred Heart Schools, Atherton',
      degree: 'High School',
      year: 2012,
    },
  ],
  yearsExperience: 10,
  exitHistory: [],
  velocityScore: 86,
  potentialScore: 81,
  photoUrl:
    'https://uploadthingy.s3.us-west-1.amazonaws.com/j8kM7VkUZ7d3kkUkpHHtVa/pasted-image.jpg',
  linkedinUrl: 'https://www.linkedin.com/in/kevmodonahoe/',
}

const kimberliZhong: Founder = {
  id: '17',
  name: 'Kimberli Zhong',
  archetype: 'CTO',
  skills: ['AI/ML', 'SaaS', 'Consumer'],
  previousCompanies: [
    { name: 'Applied Intuition', role: 'Senior Manager', years: [2022, 2023] },
    {
      name: 'Applied Intuition',
      role: 'Engineering Manager',
      years: [2021, 2022],
    },
    {
      name: 'Applied Intuition',
      role: 'Software Engineer',
      years: [2018, 2021],
    },
    { name: 'Affirm, Inc.', role: 'Software Engineer', years: [2017, 2017] },
    { name: 'Jane Street', role: 'Software Engineer', years: [2017, 2017] },
    { name: 'Airbnb', role: 'Software Engineer', years: [2016, 2016] },
    { name: 'Google', role: 'Software Engineer', years: [2015, 2015] },
  ],
  education: [
    {
      institution: 'Massachusetts Institute of Technology',
      degree:
        'Bachelor of Science (B.S.), Master of Engineering (M.Eng.), Computer Science and Engineering',
      year: 2018,
    },
    { institution: 'Dublin High School', degree: 'High School', year: 2014 },
  ],
  yearsExperience: 9,
  exitHistory: [],
  velocityScore: 87,
  potentialScore: 82,
  photoUrl:
    'https://uploadthingy.s3.us-west-1.amazonaws.com/grfSAmncQiFcUW2b1zid7L/pasted-image.jpg',
  linkedinUrl: 'https://www.linkedin.com/in/kimberlizhong/',
}

const malharPatel: Founder = {
  id: '18',
  name: 'Malhar Patel',
  archetype: 'CEO',
  skills: ['AI/ML', 'Venture Capital', 'Enterprise'],
  previousCompanies: [
    {
      name: 'Applied Intuition',
      role: 'Head of Special Projects',
      years: [2025, 2025],
    },
    {
      name: 'Applied Intuition',
      role: 'Head of Data & ML Infra',
      years: [2019, 2025],
    },
    {
      name: 'Berkeley RISE Lab',
      role: 'Researcher - Systems',
      years: [2018, 2019],
    },
    { name: 'Canvas Ventures', role: 'Venture', years: [2017, 2019] },
    { name: 'Memora Health', role: 'Early Team', years: [2015, 2019] },
    {
      name: 'Space Technologies At California (STAC)',
      role: 'Building',
      years: [2018, 2018],
    },
    {
      name: 'Space Technologies At California (STAC)',
      role: 'External Vice President',
      years: [2017, 2018],
    },
    {
      name: 'Human Rights Center, UC Berkeley School of Law',
      role: 'Researcher',
      years: [2018, 2018],
    },
    { name: 'Cisco Meraki', role: 'ML / Product Intern', years: [2018, 2018] },
    { name: 'Apple', role: 'Software Engineering Intern', years: [2017, 2017] },
  ],
  education: [
    {
      institution: 'University of California, Berkeley',
      degree:
        'Bachelor of Science (B.S.), Electrical Engineering & Computer Science',
      year: 2018,
    },
  ],
  yearsExperience: 8,
  exitHistory: [],
  velocityScore: 88,
  potentialScore: 83,
  photoUrl:
    'https://uploadthingy.s3.us-west-1.amazonaws.com/joTRUVaLp5wMndRGgGwZSM/pasted-image.jpg',
  linkedinUrl: 'https://www.linkedin.com/in/malharp/',
}

const neelBhoopalam: Founder = {
  id: '19',
  name: 'Neel Bhoopalam',
  archetype: 'CEO',
  skills: ['Enterprise', 'SaaS', 'Marketplace'],
  previousCompanies: [
    { name: 'Persona', role: 'Product', years: [2020, 2025] },
    {
      name: 'Palantir Technologies',
      role: 'Forward Deployed Engineer, Tech Lead',
      years: [2017, 2020],
    },
    {
      name: 'Kleiner Perkins Caufield & Byers',
      role: 'KPCB Engineering Fellow',
      years: [2016, 2016],
    },
    { name: 'Uber', role: 'Software Engineer', years: [2016, 2016] },
    { name: 'nod.ai', role: 'Software Engineer', years: [2014, 2016] },
    {
      name: 'Office of Los Angeles Mayor Eric Garcetti',
      role: "Mayor's Business Team - Tech Sector",
      years: [2015, 2015],
    },
    {
      name: 'Kno, Inc. (Acquired by Intel)',
      role: 'Business Development',
      years: [2012, 2013],
    },
    {
      name: 'TEDxHarkerSchool',
      role: 'Co-Founder & Curator',
      years: [2010, 2013],
    },
    { name: 'Intuit', role: 'Strategy Analyst for Fasal', years: [2012, 2012] },
    { name: 'Simpa Networks', role: 'Sales', years: [2012, 2012] },
  ],
  education: [
    {
      institution: 'University of Southern California',
      degree: 'Bachelor of Science (B.S.)',
      year: 2014,
    },
    { institution: 'The Harker School', degree: 'High School', year: 2010 },
  ],
  yearsExperience: 11,
  exitHistory: [],
  velocityScore: 89,
  potentialScore: 84,
  photoUrl:
    'https://uploadthingy.s3.us-west-1.amazonaws.com/7iBvx97MioMe7QjnzREa2v/pasted-image.jpg',
  linkedinUrl: 'https://www.linkedin.com/in/neelbhoopalam/',
}

const obaidKhan: Founder = {
  id: '20',
  name: 'Obaid Khan',
  archetype: 'CEO',
  skills: ['Enterprise', 'SaaS', 'Marketplace'],
  previousCompanies: [
    { name: 'Motive', role: 'Board Member', years: [2023, 2025] },
    {
      name: 'Motive',
      role: 'Co-Founder and Chief Operating Officer',
      years: [2013, 2024],
    },
  ],
  education: [
    {
      institution: 'UC San Diego',
      degree: "Bachelor's degree, Political Science and Government",
      year: 2012,
    },
  ],
  yearsExperience: 12,
  exitHistory: [],
  velocityScore: 90,
  potentialScore: 85,
  photoUrl:
    'https://uploadthingy.s3.us-west-1.amazonaws.com/jY6mwaqWThFut5E6NAXcug/pasted-image.jpg',
  linkedinUrl: 'https://www.linkedin.com/in/obaid-khan-b77b4357/',
}

const cindyWang: Founder = {
  id: '21',
  name: 'Cindy Wang',
  archetype: 'CTO',
  skills: ['AI/ML', 'Consumer', 'Security'],
  previousCompanies: [
    {
      name: 'Runway',
      role: 'Staff Machine Learning Engineer',
      years: [2024, 2025],
    },
    {
      name: 'Runway',
      role: 'Senior Machine Learning Engineer',
      years: [2024, 2024],
    },
    {
      name: 'Discord',
      role: 'Senior Machine Learning Engineer',
      years: [2021, 2023],
    },
    {
      name: 'Sentropy Technologies (acquired by Discord)',
      role: 'Founding Engineer',
      years: [2019, 2021],
    },
    {
      name: 'Stanford University',
      role: 'Research Assistant',
      years: [2018, 2019],
    },
    {
      name: 'Stanford University',
      role: 'Graduate Teaching Assistant',
      years: [2017, 2019],
    },
    {
      name: 'Alibaba Group',
      role: 'Research Engineer',
      years: [2018, 2018],
    },
    {
      name: 'Airbnb',
      role: 'Software Engineering Intern',
      years: [2017, 2017],
    },
    {
      name: 'Google',
      role: 'Software Engineering Intern',
      years: [2016, 2016],
    },
    { name: 'Asana', role: 'Software Engineering Intern', years: [2015, 2015] },
  ],
  education: [
    {
      institution: 'Stanford University',
      degree: 'Bachelor of Science - BS, Computer Science (Theory)',
      year: 2017,
    },
    {
      institution: 'Stanford University School of Engineering',
      degree:
        'Master of Science - MS, Computer Science (Artificial Intelligence)',
      year: 2019,
    },
  ],
  yearsExperience: 10,
  exitHistory: [],
  velocityScore: 91,
  potentialScore: 86,
  photoUrl:
    'https://uploadthingy.s3.us-west-1.amazonaws.com/dVztEsm5FisdJM1YRNYZ8G/pasted-image.jpg',
  linkedinUrl: 'https://www.linkedin.com/in/cindywang1/',
}

const nikhilThota: Founder = {
  id: '22',
  name: 'Nikhil Thota',
  archetype: 'CTO',
  skills: ['AI/ML', 'Consumer', 'Crypto/Web3'],
  previousCompanies: [
    {
      name: 'Perplexity AI',
      role: 'Member of Technical Staff',
      years: [2023, 2025],
    },
    {
      name: 'Various Startups',
      role: 'Startup Explorations',
      years: [2022, 2023],
    },
    {
      name: 'WhatsApp',
      role: 'Senior Software Engineer',
      years: [2021, 2022],
    },
    {
      name: 'dOrg',
      role: 'Human',
      years: [2021, 2022],
    },
    {
      name: 'Meta',
      role: 'Software Engineer',
      years: [2019, 2021],
    },
    {
      name: 'Meta',
      role: 'Software Engineer Intern',
      years: [2018, 2019],
    },
  ],
  education: [
    {
      institution: 'University of Florida',
      degree: 'CS + Music (Bassoon)',
      year: 2019,
    },
    {
      institution: 'Universidad Carlos III de Madrid',
      degree: 'College of Engineering (exchange semester)',
      year: 2018,
    },
  ],
  yearsExperience: 7,
  exitHistory: [
    { company: 'Texts.com', year: 2023, value: 'Acquired by Automattic' },
  ],
  velocityScore: 92,
  potentialScore: 87,
  photoUrl:
    'https://uploadthingy.s3.us-west-1.amazonaws.com/2psh2KaeBcYsUe8eD52K7W/pasted-image.jpg',
  linkedinUrl: 'https://www.linkedin.com/in/thot/',
}

const vickiCheung: Founder = {
  id: '23',
  name: 'Vicki Cheung',
  archetype: 'CTO',
  skills: ['AI/ML', 'Security', 'SaaS'],
  previousCompanies: [
    { name: 'Gantry', role: 'Co-Founder / CTO', years: [2020, 2024] },
    {
      name: 'Lyft',
      role: 'Senior Staff Software Engineer',
      years: [2020, 2020],
    },
    { name: 'Lyft', role: 'Engineering Manager', years: [2018, 2019] },
    {
      name: 'OpenAI',
      role: 'Head Of Infrastructure & Founding Engineer',
      years: [2015, 2017],
    },
    {
      name: 'TrueVault',
      role: 'Staff Software Engineer and Engineering Lead',
      years: [2014, 2015],
    },
    { name: 'Duolingo', role: 'Founding Engineer', years: [2010, 2014] },
  ],
  education: [
    {
      institution: 'Carnegie Mellon University',
      degree: 'BS Computer Science',
      year: 2011,
    },
    {
      institution: 'Chinese International School',
      degree: 'High School',
      year: 2007,
    },
  ],
  yearsExperience: 14,
  exitHistory: [{ company: 'Gantry', year: 2024, value: 'Co-Founder Exit' }],
  velocityScore: 94,
  potentialScore: 96,
  photoUrl:
    'https://uploadthingy.s3.us-west-1.amazonaws.com/e6otzubvDcYLLH4zMEvnkC/pasted-image.jpg',
  linkedinUrl: 'https://www.linkedin.com/in/vickicheung/',
}

const angelaSheu: Founder = {
  id: '24',
  name: 'Angela Sheu',
  archetype: 'CTO',
  skills: ['Security', 'AI/ML', 'Enterprise'],
  previousCompanies: [
    {
      name: 'Abnormal AI',
      role: 'Senior Director of Engineering, Head of Inbound Email Security',
      years: [2023, 2025],
    },
    {
      name: 'Pinterest',
      role: 'Engineering Manager, Core Product Indexing',
      years: [2020, 2022],
    },
    {
      name: 'Pinterest',
      role: 'Tech Lead, HomeFeed Infrastructure',
      years: [2018, 2020],
    },
    {
      name: 'Pinterest',
      role: 'Software Engineer',
      years: [2015, 2018],
    },
    {
      name: 'Google',
      role: 'Software Engineering Intern',
      years: [2014, 2014],
    },
    {
      name: 'Microsoft',
      role: 'Explorer Intern',
      years: [2013, 2013],
    },
  ],
  education: [
    {
      institution: 'University of California, Berkeley',
      degree: 'BS, EECS',
      year: 2015,
    },
    {
      institution: 'St. Francis High School',
      degree: 'High School Diploma',
      year: 2011,
    },
  ],
  yearsExperience: 10,
  exitHistory: [],
  velocityScore: 94,
  potentialScore: 89,
  photoUrl:
    'https://uploadthingy.s3.us-west-1.amazonaws.com/7k1EifXgu48rSKARTxjEtJ/pasted-image.jpg',
  linkedinUrl: 'https://www.linkedin.com/in/angelasheu/',
}

const ericZhang: Founder = {
  id: '25',
  name: 'Eric Zhang',
  archetype: 'CTO',
  skills: ['AI/ML', 'Enterprise', 'SaaS'],
  previousCompanies: [
    {
      name: 'Modal',
      role: 'Member of Technical Staff',
      years: [2024, 2025],
    },
    { name: 'Modal', role: 'Founding Engineer', years: [2022, 2024] },
    { name: 'Prosper Robotics', role: 'Contractor', years: [2022, 2022] },
    { name: 'Convex', role: 'Software Engineer', years: [2021, 2021] },
    {
      name: 'Jump Trading',
      role: 'Quantitative Research Intern',
      years: [2021, 2021],
    },
    {
      name: 'Scale AI',
      role: 'Software Engineering Intern',
      years: [2020, 2021],
    },
    { name: 'NVIDIA', role: 'Architecture Intern', years: [2020, 2020] },
  ],
  education: [
    {
      institution: 'Harvard University',
      degree: 'MS, Computer Science',
      year: 2023,
    },
    {
      institution: 'Harvard University',
      degree: 'BA, Computer Science and Mathematics',
      year: 2023,
    },
  ],
  yearsExperience: 3,
  exitHistory: [],
  velocityScore: 92,
  potentialScore: 95,
  photoUrl:
    'https://uploadthingy.s3.us-west-1.amazonaws.com/wQexfyrw1dE4Yacb31BYWe/pasted-image.jpg',
  linkedinUrl: 'https://www.linkedin.com/in/ekzhang/',
}

const erickFriis: Founder = {
  id: '26',
  name: 'Erick Friis',
  archetype: 'CTO',
  skills: ['AI/ML', 'Engineering', 'Enterprise'],
  previousCompanies: [
    {
      name: 'LangChain',
      role: 'Founding Engineer',
      years: [2023, 2025],
    },
    {
      name: 'South Park Commons',
      role: 'Member',
      years: [2022, 2023],
    },
    {
      name: 'Chestnut',
      role: 'Co-Founder',
      years: [2022, 2022],
    },
    {
      name: 'Instabase',
      role: 'Software Engineer',
      years: [2019, 2022],
    },
    {
      name: 'Akamai Technologies',
      role: 'Research Software Engineer',
      years: [2018, 2019],
    },
    {
      name: 'Sonos, Inc.',
      role: 'Advanced Concepts Engineer',
      years: [2017, 2018],
    },
    {
      name: 'Spy Pond Partners',
      role: 'Software Engineer',
      years: [2015, 2017],
    },
  ],
  education: [
    {
      institution: 'Massachusetts Institute of Technology',
      degree:
        'Master of Engineering, Electrical Engineering and Computer Science',
      year: 2019,
    },
    {
      institution: 'Massachusetts Institute of Technology',
      degree: "Bachelor's Degree, Electrical Engineering and Computer Science'",
      year: 2018,
    },
  ],
  yearsExperience: 10,
  exitHistory: [],
  velocityScore: 96,
  potentialScore: 91,
  photoUrl:
    'https://uploadthingy.s3.us-west-1.amazonaws.com/5BMKazDq9bJ6Bm3VakZ45c/pasted-image.jpg',
  linkedinUrl: 'https://www.linkedin.com/in/efriis/',
}

const jeffChang: Founder = {
  id: '27',
  name: 'Jeff Chang',
  archetype: 'CEO',
  skills: ['Health', 'Consumer', 'Marketplace'],
  previousCompanies: [
    { name: 'LinkedIn', role: 'Executive', years: [2015, 2022] },
    { name: 'Twitter', role: 'Manager', years: [2010, 2015] },
  ],
  education: [
    { institution: 'Top University', degree: 'Advanced Degree', year: 2010 },
    { institution: 'Good College', degree: 'Bachelor Degree', year: 2006 },
  ],
  yearsExperience: 19,
  exitHistory: [],
  velocityScore: 97,
  potentialScore: 92,
  photoUrl:
    'https://uploadthingy.s3.us-west-1.amazonaws.com/awMysV4xbeyaQ3ncYstpmU/pasted-image.jpg',
  linkedinUrl: 'https://www.linkedin.com/in/jeff-chang-82467459/',
}

const founder28: Founder = {
  id: '28',
  name: 'MG (Myung Geun) Chi',
  archetype: 'CTO',
  skills: ['AI/ML', 'Fintech', 'Engineering'],
  previousCompanies: [
    { name: 'Mindy', role: 'Founding Engineer', years: [2023, 2025] },
    { name: 'Startup', role: 'Co-Founder', years: [2022, 2023] },
    { name: 'Mutiny', role: 'Founding Engineer', years: [2020, 2022] },
    { name: 'Affirm, Inc.', role: 'Software Engineer', years: [2017, 2020] },
    { name: 'AMPLab', role: 'Researcher', years: [2016, 2016] },
    { name: 'Meta', role: 'Software Engineer Intern', years: [2015, 2015] },
    { name: 'Google', role: 'Software Engineer Intern', years: [2014, 2014] },
  ],
  education: [
    {
      institution: 'University of California, Berkeley',
      degree: 'BS, Electrical Engineering and Computer Science',
      year: 2017,
    },
    {
      institution: 'Lynbrook High School',
      degree: 'High School Diploma',
      year: 2013,
    },
  ],
  yearsExperience: 9,
  exitHistory: [],
  velocityScore: 98,
  potentialScore: 93,
  photoUrl:
    'https://uploadthingy.s3.us-west-1.amazonaws.com/8Z9quetANXRDjhtygLwJZK/pasted-image.jpg',
  linkedinUrl: 'https://www.linkedin.com/in/mgchi/',
}

const founder29: Founder = {
  id: '29',
  name: 'Vincent Sunn Chen',
  archetype: 'CTO',
  skills: ['AI/ML', 'Computer Vision', 'Data Systems'],
  previousCompanies: [
    { name: 'Snorkel AI', role: 'VP & Founding Engineer', years: [2019, 2025] },
    {
      name: 'Stanford University',
      role: 'Researcher (Stanford AI Lab) - Snorkel',
      years: [2017, 2019],
    },
    { name: 'Tesla', role: 'AI Engineer - Autopilot', years: [2018, 2018] },
  ],
  education: [
    {
      institution: 'Stanford University',
      degree: "Master's degree, Computer Science",
      year: 2019,
    },
    {
      institution: 'Stanford University',
      degree: "Bachelor's degree, Computer Science",
      year: 2017,
    },
  ],
  yearsExperience: 7,
  exitHistory: [],
  velocityScore: 94,
  potentialScore: 94,
  photoUrl:
    'https://uploadthingy.s3.us-west-1.amazonaws.com/kGYJRsSiVsficj1MEFtbyM/pasted-image.jpg',
  linkedinUrl: 'https://www.linkedin.com/in/vincentsunnchen/',
}

const founder30: Founder = {
  id: '30',
  name: 'Yuzhou Lee',
  archetype: 'CTO',
  skills: ['AI/ML', 'Security', 'Engineering'],
  previousCompanies: [
    {
      name: 'Abnormal Security',
      role: 'Staff Software Engineer',
      years: [2022, 2025],
    },
    {
      name: 'Abnormal Security',
      role: 'Founding Engineer',
      years: [2018, 2022],
    },
    { name: 'Twitter', role: 'Senior Software Engineer', years: [2016, 2018] },
    { name: 'FarmShots', role: 'Co-Founder', years: [2014, 2016] },
    {
      name: 'TellApart',
      role: 'Software Engineer Intern',
      years: [2015, 2015],
    },
    {
      name: 'Singapore Army',
      role: 'Lieutenant, Combat Engineers',
      years: [2010, 2011],
    },
  ],
  education: [
    {
      institution: 'Duke University',
      degree: 'Bachelor of Science - BS, Computer Science',
      year: 2014,
    },
    {
      institution: 'Raffles Institution',
      degree: 'High School',
      year: 2010,
    },
  ],
  yearsExperience: 10,
  exitHistory: [
    { company: 'FarmShots', year: 2018, value: 'Acquired by Syngenta' },
  ],
  velocityScore: 95,
  potentialScore: 95,
  photoUrl:
    'https://uploadthingy.s3.us-west-1.amazonaws.com/am772XuZcZWtnDiv4NMxJ2/pasted-image.jpg',
  linkedinUrl: 'https://www.linkedin.com/in/yuzhoulee/',
}

// Combine all founders into a single array
export const founderData: Founder[] = [
  vijayKarunamurthy,
  nidhiShanbhag,
  rubenMayer,
  hariSrinivasan,
  tejasSundaresan,
  banshiShah,
  tommyWang,
  yongxingDeng,
  kevinChan,
  veeralPatel,
  andrewWerner,
  anubhavJain,
  divannyLamas,
  joshuaPenman,
  kailiLiang,
  kevinDonahoe,
  kimberliZhong,
  malharPatel,
  neelBhoopalam,
  obaidKhan,
  cindyWang,
  nikhilThota,
  vickiCheung,
  angelaSheu,
  ericZhang,
  erickFriis,
  jeffChang,
  founder28,
  founder29,
  founder30,
]

// Calculate compatibility between two founders
export function calculateCompatibility(
  founder1: Founder,
  founder2: Founder,
): CompatibilityScore {
  // Special case for the highlighted pairing example
  if (
    (founder1.id === '1' && founder2.id === '2') ||
    (founder1.id === '2' && founder2.id === '1')
  ) {
    return {
      overall: 94,
      skills: 85,
      workingStyle: 92,
      velocityMatch: 96,
      archetypeBalance: 98,
      details: {
        strengths: [
          'Complementary technical and execution skills',
          'Both have experience at high-growth companies',
          'Similar velocity scores indicate matching work pace',
          'Education backgrounds create strong network effect',
        ],
        watchOuts: [
          'No previous working history together',
          'Potential overlap in product decision-making',
        ],
      },
    }
  }
  // Special case for Divanny Lamas and Kevin Chan based on data science analysis
  if (
    (founder1.id === '13' && founder2.id === '9') ||
    (founder1.id === '9' && founder2.id === '13')
  ) {
    // Determine if we're showing real or fictional data based on founder names
    const isRealData =
      founder1.name === 'Divanny Lamas' || founder2.name === 'Divanny Lamas'
    // Choose the appropriate strengths based on whether we're showing real or fictional data
    const strengths = isRealData
      ? [
          'Divanny brings GTM, fundraising and board experience (CEO Transposit); Kevin is a staff-level engineer who has designed infra at Meta and Ramp',
          'Both have operated inside <15-person teams and scaled to triple-digit headcount: Divanny at Transposit, Kevin at Venue and Ramp',
          'Divanny exited Transposit in 2024; Kevin joined Ramp in 2023 but remains an early-stage builder with recent founder experience',
          'Classic Visionary-Builder split: Divanny has board-room credentials and repeat fundraising; Kevin owns technical architecture and IC excellence',
          'Zero shared employers or schools → 94% network union breadth. Combined contacts span Splunk, Google, Sutter Hill, Meta, Venue/Ramp',
        ]
      : [
          'Kathryn brings GTM, fundraising and board experience (CEO Breakthrough Startup, CBO ClickUp); Seven of Nine is a staff-level engineer who has designed infra at Meta and Unicorn Startup',
          'Both have operated inside <15-person teams and scaled to triple-digit headcount: Kathryn at Breakthrough Startup, Seven of Nine at Unicorn Startup/Seed Startup',
          'Kathryn exited Breakthrough Startup in 2024; Seven of Nine joined Unicorn Startup in 2023 but remains an early-stage builder with recent founder experience',
          'Classic Visionary-Builder split: Kathryn has board-room credentials and repeat fundraising; Seven of Nine owns technical architecture and IC excellence',
          'Zero shared employers or schools → 94% network union breadth. Combined contacts span Unicorn Startup, Google, VC Firm, Meta, Sequoia-backed Unicorn Startup',
        ]
    return {
      overall: 92,
      skills: 88,
      workingStyle: 92,
      velocityMatch: 90,
      archetypeBalance: 97,
      details: {
        strengths: strengths,
        watchOuts: [
          'No previous collaboration history to validate working relationship',
          'Different industry backgrounds may require alignment',
        ],
      },
    }
  }
  // Special case for Divanny Lamas and Eric Zhang
  if (
    (founder1.id === '13' && founder2.id === '25') ||
    (founder1.id === '25' && founder2.id === '13')
  ) {
    return {
      overall: 96,
      skills: 88,
      workingStyle: 94,
      velocityMatch: 90,
      archetypeBalance: 98,
      details: {
        strengths: [
          'Both Harvard alums with complementary technical backgrounds',
          "Kathryn's Unicorn Startup scaling experience pairs with Eric's Modal infrastructure",
          'Shared big tech experience (Google/Unicorn Startup) and startup exits',
          "Eric's technical depth complements Kathryn's product/UX strengths",
        ],
        watchOuts: ['No previous working history together'],
      },
    }
  }
  // Special case for Tejas Sundaresan and Vijay Karunamurthy
  if (
    (founder1.id === '5' && founder2.id === '1') ||
    (founder1.id === '1' && founder2.id === '5')
  ) {
    return {
      overall: 93,
      skills: 90,
      workingStyle: 88,
      velocityMatch: 93,
      archetypeBalance: 95,
      details: {
        strengths: [
          'Combined AI expertise includes Databricks Mosaic, Scale AI, and YouTube discovery.',
          'Both SF-based with strong academic backgrounds (MIT/Stanford)',
          'Shared focus on healthcare/ML applications',
          "Vijay's MBA bridges Tejas' product focus for a balanced team",
        ],
        watchOuts: [
          'Potential overlap in technical decision-making',
          'Different career trajectories may affect strategic alignment',
        ],
      },
    }
  }
  // Special case for Nidhi Shanbhag and Kevin Chan
  if (
    (founder1.id === '2' && founder2.id === '9') ||
    (founder1.id === '9' && founder2.id === '2')
  ) {
    return {
      overall: 91,
      skills: 87,
      workingStyle: 86,
      velocityMatch: 92,
      archetypeBalance: 96,
      details: {
        strengths: [
          "Nidhi's PE/VC experience complements Kevin's engineering expertise",
          'SF-based with global mindsets and complementary skills',
          "Nidhi's ventures/BD background pairs with Kevin's technical infrastructure knowledge",
          'Shared interest in emerging technologies and fintech applications',
        ],
        watchOuts: [
          'Different industry backgrounds may require alignment',
          'No previous collaboration history',
        ],
      },
    }
  }
  // For other pairings, calculate a realistic score
  // Skill complementarity (different skills are good)
  const sharedSkills = founder1.skills.filter((skill) =>
    founder2.skills.includes(skill),
  )
  const skillsScore = Math.min(
    100,
    60 +
      (founder1.skills.length + founder2.skills.length - sharedSkills.length) *
        5,
  )
  // Archetype balance (different archetypes are good)
  const archetypeScore = founder1.archetype === founder2.archetype ? 60 : 90
  // Velocity match (similar velocity is good)
  const velocityDiff = Math.abs(founder1.velocityScore - founder2.velocityScore)
  const velocityScore = Math.max(50, 100 - velocityDiff)
  // Working style (based on archetype and velocity)
  const workingStyleScore = Math.min(
    100,
    archetypeScore * 0.6 + velocityScore * 0.4,
  )
  // Overall score with weighted components (redistributed weights after removing network effect)
  const overall = Math.round(
    skillsScore * 0.3 +
      archetypeScore * 0.25 +
      velocityScore * 0.25 +
      workingStyleScore * 0.2,
  )
  // Generate appropriate strengths and watchouts
  const strengths = []
  const watchOuts = []
  if (skillsScore > 80) strengths.push('Highly complementary skill sets')
  if (archetypeScore > 80) strengths.push('Strong archetype balance')
  if (velocityScore > 80)
    strengths.push('Well-matched work pace and execution style')
  if (skillsScore < 70) watchOuts.push('Limited skill complementarity')
  if (archetypeScore < 70) watchOuts.push('Potential archetype conflict')
  if (velocityScore < 70)
    watchOuts.push('Mismatched work pace may cause friction')
  return {
    overall,
    skills: skillsScore,
    workingStyle: workingStyleScore,
    velocityMatch: velocityScore,
    archetypeBalance: archetypeScore,
    details: {
      strengths: strengths.length
        ? strengths
        : ['No significant strengths identified'],
      watchOuts: watchOuts,
    },
  }
}
